import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Calendar from "./Calendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import axios from "axios";
import { viewerDisabledProps } from "../utils/permissions";
const EmployeeDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const employee = state?.employee;
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editEntryTime, setEditEntryTime] = useState("");
  const [editExitTime, setEditExitTime] = useState("");
  const [attendanceid, setattendanceid] = useState("");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [attendanceData, setAttendanceData] = useState([]);
  const [deletemployeeid, setdeletemployeeid] = useState();
  const [rows, setRows] = useState([]);
  const [file, setFile] = useState(null);
  const nextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const prevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };
  console.log("Employee data:", employee);
  const handleemployeid = (id) => {
    setdeletemployeeid(id);
  };
  useEffect(() => {
    if (deletemployeeid) {
    }
  }, [deletemployeeid]);

  const deleteempolyeedata = async () => {
    if (!file) return alert("Please select a file first");
    const formData = new FormData();
    formData.append("profilePicture", file);
    formData.append("employeid", deletemployeeid);
    try {
      const res = await axios.post(
        `https://ims-attendanceback.indevconsultancy.in/api/profile-update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Profile picture updated successfully");
      navigate(`/employeeList`);
    } catch (err) {
      console.error("Upload failed", err);
    }
  };

  useEffect(() => {
    const apiData = [
      { date: "2025-06-15", status: "present" },
      { date: "2025-06-16", status: "absent" },
      { date: "2025-06-17", status: "leave" },
    ];
    const map = {};
    apiData.forEach((item) => {
      map[item.date] = item.status;
    });
    setAttendanceData(map);
    fetch(
      `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/?employee_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setRows(data);

        // ✅ Convert API data to status map
        const mappedAttendance = {};
        data.forEach((entry) => {
          const date = new Date(entry.entry_time).toISOString().split("T")[0];

          if (entry.entry_time || entry.exit_time) {
            mappedAttendance[date] = "present";
          }
          // //  else if (entry.entry_time && !entry.exit_time) {
          // //   mappedAttendance[date] = "leave"; // Or "partial"
          // // }
          else {
            mappedAttendance[date] = "absent"; // fallback if needed
          }
        });

        setAttendanceData(mappedAttendance); // ✅ Send formatted data
      })
      .catch(console.error);
  }, []);

  if (!employee) {
    return (
      <div className="container mt-5">
        <div className="alert alert-warning text-center">
          <h5>No employee data available.</h5>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/employeeList")}
          >
            Back to List
          </button>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="container my-5">
      <div className="card shadow border-0 rounded-4 p-4">
        <div className="row g-4">
          {/* Left: Profile Image */}
          <div className="col-md-4 text-center">
            <img
              src={
                employee.profileimg ||
                "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
              }
              alt="Profile"
              className="img-fluid rounded-4 border"
              style={{ maxHeight: "250px", objectFit: "cover" }}
            />
            <h5 className="mt-3">{employee.emp_name}</h5>

            {/* Change Profile Picture Button */}
            <button
              className="btn btn-sm btn-outline-primary mt-2"
              data-bs-toggle="modal"
              data-bs-target="#profilePicModal"
              onClick={() => handleemployeid(employee.empdetailsid)}
            >
              Change Profile Picture
            </button>
          </div>

          {/* Right: Employee Details */}
          <div className="col-md-8">
            <h4 className="mb-4 border-bottom pb-2">Employee Information</h4>

            <div className="row mb-3">
              <div className="col-sm-5 fw-semibold">
                Father's / Husband's Name:
              </div>
              <div className="col-sm-7">{employee.father_name || "-"}</div>
            </div>

            <div className="row mb-3">
              <div className="col-sm-5 fw-semibold">Mobile Number:</div>
              <div className="col-sm-7">{employee.emp_mobile_no || "-"}</div>
            </div>

            <div className="row mb-3">
              <div className="col-sm-5 fw-semibold">Date of Joining:</div>
              <div className="col-sm-7">
                {formatDate(employee.date_of_joining) || "-"}
              </div>
            </div>

            {employee.date_of_exiting && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">Date of Exit:</div>
                <div className="col-sm-7">
                  {formatDate(employee.date_of_exiting)}
                </div>
              </div>
            )}

            {employee.date_of_birth && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">Date of Birth:</div>
                <div className="col-sm-7">
                  {employee.date_of_birth.slice(0, 10)}
                </div>
              </div>
            )}

            {employee.kithchenid && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">Kitchen:</div>
                <div className="col-sm-7">{employee.kitchen_name || employee.kithchenid}</div>
              </div>
            )}

            {employee.account_no && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">Account Number:</div>
                <div className="col-sm-7">{employee.account_no}</div>
              </div>
            )}

            {employee.ifsc_code && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">IFSC Code:</div>
                <div className="col-sm-7">{employee.ifsc_code}</div>
              </div>
            )}

            {employee.address && employee.address !== "nan" && (
              <div className="row mb-3">
                <div className="col-sm-5 fw-semibold">Address:</div>
                <div className="col-sm-7">{employee.address}</div>
              </div>
            )}
          </div>
        </div>

        <div className="mt-4 text-end">
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate("/employeeList")}
          >
            Back
          </button>
        </div>
      </div>

      <div className="card shadow border-0 my-5">
        <div className="card-header bg-skyBlue text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <h5 className="mb-2 mb-md-0">
            <i className="bi bi-calendar3 me-2"></i> Attendance Calendar
          </h5>
          <div className="d-flex gap-2 flex-wrap justify-content-center justify-content-md-end calendar-nav-buttons">
            <button
              onClick={prevMonth}
              className="btn btn-nav px-3 py-1 text-white"
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Prev
            </button>
            <button
              onClick={nextMonth}
              className="btn btn-nav px-3 py-1 text-white"
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </div>
        <div className="card-body p-3">
          <div className="calendar-wrapper mx-auto">
            <Calendar
              date={currentDate}
              attendance={attendanceData}
              onDateSelect={(date) => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const selectedDate = new Date(date);
                selectedDate.setHours(0, 0, 0, 0);

                // Salary cycle: 26 se 25 tak. Editing window = pichhle POORE
                // cycle ki 26 tarikh se aaj tak — taaki 25 ke baad salary
                // process karte time pura pichhla cycle (31 din) edit ho sake.
                //  - aaj 26 ya baad  → window start = pichhle mahine ki 26
                //  - aaj 25 ya pehle → window start = 2 mahine pehle ki 26
                //    (kyunki pichhla cycle abhi process ho raha hota hai)
                const windowStart = new Date(
                  today.getFullYear(),
                  today.getMonth() - (today.getDate() >= 26 ? 1 : 2),
                  26
                );

                const isValidDate =
                  selectedDate >= windowStart && selectedDate <= today;

                if (isValidDate) {
                  const nextDate = new Date(selectedDate);
                  nextDate.setDate(nextDate.getDate() + 1);
                  const formatted = nextDate.toISOString().split("T")[0];


                  navigate(`/edit-attendance/${formatted}/${employee.kithchenid}/${employee.empdetailsid}`);
                } else {
                  alert(
                    "Only dates from the past 31 days (including today) are allowed."
                  );
                }
              }}
            />
          </div>
        </div>
      </div>

      <div className="card card shadow border-0 my-5">
        <div className="card-header bg-skyBlue text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <h5 className="mb-2 mb-md-0">
            <i className="bi bi-calendar3 me-2"></i> Attendance Log
          </h5>
        </div>
        <div className="table-responsive  p-2">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Entry Time</th>
                <th>Exit Time</th>
                <th>Photo</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((emp) => {
                const entryDate = new Date(emp.entry_time);
                const exitDate = emp.exit_time ? new Date(emp.exit_time) : null;
                const formatDate = (dt) =>
                  dt.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  });

                const formatTime = (dt) =>
                  dt.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  });

                return (
                  <tr key={emp.attendanceid}>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {entryDate ? formatDate(entryDate) : "-"}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {entryDate ? formatTime(entryDate) : "-"}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {exitDate ? formatTime(exitDate) : "-"}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {emp.entryimage ? (
                        <img
                          src={emp.entryimage}
                          alt=""
                          width="40"
                          height="30"
                          style={{ objectFit: "cover" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {/* <button className="btn btn-sm btn-warning me-1 bg-orange text-white">
                        <FontAwesomeIcon icon={faUserPen} />
                      </button> */}
                      <button
                        className="btn btn-sm btn-warning me-1 bg-orange text-white"
                        onClick={() => {
                          setSelectedRow(emp);
                          setEditEntryTime(emp.entry_time || "");
                          setEditExitTime(emp.exit_time || "");
                          setattendanceid(emp.attendanceid || "");
                          setShowModal(true);
                        }}
                        {...viewerDisabledProps()}
                      >
                        <FontAwesomeIcon icon={faUserPen} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-skyBlue text-white">
                <h5 className="modal-title">Edit Attendance</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Entry Time</label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={editEntryTime}
                    onChange={(e) => setEditEntryTime(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Exit Time</label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={editExitTime}
                    onChange={(e) => setEditExitTime(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  {...viewerDisabledProps()}
                  onClick={async () => {
                    console.log("Updated Entry:", editEntryTime);
                    console.log("Updated Exit:", editExitTime);

                    try {
                      const response = await fetch(
                        "https://ims-attendanceback.indevconsultancy.in/api/update-time",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify({
                            attendatne_id: attendanceid,
                            entry_time: editEntryTime,
                            exit_time: editExitTime,
                          }),
                        }
                      );

                      const data = await response.json();
                      console.log("Server Response:", data);

                      // Optionally hide modal or show success message
                      setShowModal(false);
                    } catch (error) {
                      console.error("Error while saving changes:", error);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Changing Profile Picture */}
      <div
        className="modal fade"
        id="profilePicModal"
        tabIndex="-1"
        aria-labelledby="profilePicModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-skyBlue text-white">
              <h5 className="modal-title" id="profilePicModalLabel">
                Change Profile Picture
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={(e) => handleFileChange(e)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => deleteempolyeedata()}
                {...viewerDisabledProps()}
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
